var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 28,
    height: 24,
    id: "arrowLeft",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAYBAMAAAAbsoCxAAAAAXNSR0IB2cksfwAAABVQTFRFAAAAWTv/Wj7/WT7/WT7/WT7/WD3/Y8kcHgAAAAd0Uk5TAF/v3//vYFbDEy0AAACKSURBVHicY2QAASH582CagRFMODPuRuKKGPzfi+AyOjMw7UJwRQwYZBbAuUiSIC6SJJCLLAnkIksyMKJIMjACJRHgLaOJABKXkVFFAYn7nzHlARL3ESObHcPf/QjVDEDpMx8QXBRpoCORpYFcZGmQB5GkQVwkaXDgpDxACSs2O+SwYmBIPnwLwgUA9Mom+BK+Vt0AAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Background",
    href: "#arrowLeft",
    x: 2,
    y: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.c857598fbc9babe5adb06d8c42d9e5fd.svg";
export { ForwardRef as ReactComponent };